module.exports = __webpack_public_path__ + "img/iconConcreteTruck.6e55f5d0.svg";